import { useQuery } from '@tanstack/react-query';
import { ExtractFnReturnType } from '@/lib/react-query';
import { getConsolidationDataByType } from '@/features/dashboard/api/getConsolidationDataByType.ts';
import { TypesConsolidationData } from '@/types/ConsolidationData.ts';

type QueryFnType = typeof getConsolidationDataByType;

function useConsolidationScoreMovimentacaoEscolar(year?: number) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-consolidation-score-movimentacao-escolar', year],
    queryFn: () => getConsolidationDataByType(TypesConsolidationData.SCORE_MOVIMENTACAO_ESCOLAR, year ? String(year) : undefined),
  });
}

export { useConsolidationScoreMovimentacaoEscolar };
